module.exports = __webpack_public_path__ + "img/img23.d84cceb6.svg";